import {useEffect, useState} from "react";

function usePersistentState(key, initialValue) {
    // Get the initial state from localStorage or use the provided initial value
    const [state, setState] = useState(() => {
        const savedValue = localStorage.getItem(key);
        return savedValue !== null ? JSON.parse(savedValue) : initialValue;
    });

    // Use effect to update localStorage whenever the state changes
    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(state));
    }, [key, state]);

    return [state, setState];
}

export default usePersistentState;